(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/notched-outline", [], factory);
	else if(typeof exports === 'object')
		exports["notched-outline"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["notched-outline"] = factory();
})(this, function() {
return 